import React from 'react'

export default function Sparkles({
  id,
  starsCount = 100,
  sparklingDelay = 10,
}: {
  id: number
  starsCount?: number
  sparklingDelay?: number
}) {
  return [...Array(starsCount)].map((_, i) => (
    <i
      key={`${id}-${i}`}
      style={{
        top: Math.random() * 100 + '%',
        left: Math.random() * 100 + '%',
        animationDelay: Math.random() * sparklingDelay + 's',
      }}
    ></i>
  ))
}
